import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@shared/services/api/apiRequest";
import {
  USER_PHASE_ACTIONS_SET,
  usePlatformDispatch,
} from "../PlatformContext";

export type Args = {
  isEnabled?: boolean;
  refetchOnWindowFocus?: boolean;
  refetchOnReconnect?: boolean;
};

export function useFetchUserPhaseActions(
  {
    isEnabled = true,
    refetchOnWindowFocus = true,
    refetchOnReconnect = true,
  }: Args = {
    isEnabled: true,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  }
) {
  const dispatch = usePlatformDispatch();

  const query = useQuery({
    queryKey: ["user-phase-actions"],

    queryFn: async () => {
      return await apiRequest(`/api/get-my-actions/`, "GET");
    },

    // Select the time_slots from the response
    select: (data) => {
      return data.actions;
    },

    // Disable retry to avoid repeated failures
    retry: false,

    enabled: isEnabled,
    refetchOnWindowFocus: refetchOnWindowFocus,
    refetchOnReconnect: refetchOnReconnect,
  });

  useEffect(() => {
    if (query.data) {
      dispatch({
        type: USER_PHASE_ACTIONS_SET,
        payload: { userPhaseActions: query.data },
      });
    }
  }, [query.data]);

  return query;
}

export default useFetchUserPhaseActions;
